import React from 'react';
import { observer } from 'mobx-react-lite';
import toastStore from '../store/ToastStore';
import '../styles/Toast.css';

// Mounted once at the app root (see App.tsx) — floats above everything,
// including popups, regardless of route.
const ToastContainer = observer(() => {
    if (toastStore.items.length === 0) return null;

    return (
        <div className='toast-container'>
            {toastStore.items.map((t) => (
                <div key={t.id}
                     className={`toast toast-${t.type}`}
                     onClick={() => toastStore.remove(t.id)}
                     title='Скрыть'>
                    {t.message}
                </div>
            ))}
        </div>
    );
});

export default ToastContainer;
